'use client';

// fonts
import '@fontsource/lora/400.css';
import '@fontsource/lora/500.css';
import '@fontsource/lora/600.css';
import '@fontsource/lora/700.css';
import '@fontsource/lora/400-italic.css';
import '@fontsource/lora/500-italic.css';
import '@fontsource/lora/600-italic.css';
import '@fontsource/lora/700-italic.css';
import '@fontsource/work-sans/100.css';
import '@fontsource/work-sans/200.css';
import '@fontsource/work-sans/300.css';
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';
import '@fontsource/work-sans/800.css';
import '@fontsource/work-sans/900.css';

// theme definitions
import typography from './typography';
import color from './color';
import breakpoint, { breakpointValues } from './breakpoint';
import spacing from './spacing';
import elevation from './elevation';
import radius from './radius';

// styled-components
import { css } from 'styled-components';

// directory

export const theme = {
  typography,
  color,
  breakpoint,
  breakpointValues,
  spacing,
  elevation,
  radius,
  pressed: (pressedCss: any) => {
    return css`
      ${pressedCss}
      &:hover,
          &:active {
        ${pressedCss}
      }
    `;
  },
  innerBorder: (border: string, borderRadius?: number) => {
    return (
      border &&
      css`
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border: ${border};
          ${borderRadius && `border-radius: ${borderRadius}px`};
        }
      `
    );
  },
};

export default theme;
export type Theme = typeof theme;
